import Banner from './components/Banner';
import Footer from './components/Footer';
import FooterBottom from './components/FooterBottom';
import Home from './components/Home';
import MigrationModule from './components/MigrationModule';
import SegregationModule from './components/SegregationModule';
import MobilityModule from './components/MobilityModule';
import Login from './components/admin/Login';
import MainEdit from './components/admin/MainEdit';
import MigrationEdit from './components/admin/MigrationEdit';
import MobilityEdit from './components/admin/MobilityEdit';
import SegregationEdit from './components/admin/SegregationEdit';
import FilterFeaturesEdit from './components/admin/FilterFeaturesEdit';
import DerivedFeaturesEdit from './components/admin/DerivedFeaturesEdit';
import SegregationFeaturesEdit from './components/admin/SegregationFeaturesEdit';
import LayersConfiguration from './components/admin/LayersConfiguration';
import ObservatoryPagesAdd from './components/admin/ObservatoryPagesAdd';
import ObservatoryPages from './components/admin/ObservatoryPages';
import Resources from './components/admin/Resources';

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Visualizations from './components/Visualizations';
import { useState, useContext, useEffect } from "react";
import { JSONContext } from './Store'
import { store } from './Store';
// import { isLoggedIn } from "./utils/utils";
import { isLoggedIn } from "./components/admin/apiCalls";
import { getMainConfig } from "./components/admin/apiCalls"
import Observatory from './components/observatory/Observatory';
import ChangePassword from './components/admin/ChangePassword';

function App(props) {

  const { WEB_FOLDER } = window.config;

	const { state, dispatch } = useContext(store);

  const [responseJSON, setResponseJSON] = useState([]);
  const [firstResponseJSON, setFirstResponseJSON] = useState({});
  const [textSPC, setTextSPC] = useState('');
  const [formTypeQuery, setFormTypeQuery] = useState('');
  const [selectedDA, setSelectedDA] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});

	useEffect(() => {
		getMainConfig((data) => {
			dispatch({ type: 'SET_CONFIG', payload: data });
			// updateMainColor( '#1a8dc2' );
			
			isLoggedIn((resp) => {
				const jresp = JSON.parse(resp);
				if (jresp.status === 'success') {
					dispatch({ type: 'LOGIN_SUCCESS' });
				}
				else {
					dispatch({ type: 'LOGIN_FAIL' });
				}
			});
		});
	}, []);

  return (
    <>
    <JSONContext.Provider value={{
      responseJSON, setResponseJSON,
      firstResponseJSON, setFirstResponseJSON,
      textSPC, setTextSPC,
      formTypeQuery, setFormTypeQuery,
      selectedDA, setSelectedDA,
      isLoading, setIsLoading,
      formData, setFormData
    }}>
    <BrowserRouter basename={ WEB_FOLDER }>
    <body>
        <div className="odisea-page-layout">
          <Banner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/visualizations" element={<Visualizations />} />
              <Route path="/migration" element={<MigrationModule />} />
              <Route path="/segregation" element={<SegregationModule />} />
              <Route path="/mobility" element={<MobilityModule />} />
              <Route path="/observatory" element={<Observatory />} />
              <Route path="/observatory/:pagecode" element={<Observatory />} />
              <Route path="/login" element={<Login />} />
              { state.loggedIn ? <Route path="/admin" element={<Navigate replace to="/admin/main" /> }/> : <Route path="/admin" element={<Navigate replace to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/main" dispatch={props.dispatch} element={<MainEdit />} /> : <Route path="/admin/main" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/migration" dispatch={props.dispatch} element={<MigrationEdit />} /> : <Route path="/admin/migration" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/mobility" dispatch={props.dispatch} element={<MobilityEdit />} /> : <Route path="/admin/mobility" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/segregation" dispatch={props.dispatch} element={<SegregationEdit />} /> : <Route path="/admin/segregation" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/filter-features" dispatch={props.dispatch} element={<FilterFeaturesEdit />} /> : <Route path="/admin/filter-features" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/derived-features" dispatch={props.dispatch} element={<DerivedFeaturesEdit />} /> : <Route path="/admin/derived-features" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/segregation-features" dispatch={props.dispatch} element={<SegregationFeaturesEdit />} /> : <Route path="/admin/segregation-features" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/layers-configuration" dispatch={props.dispatch} element={<LayersConfiguration />} /> : <Route path="/admin/layers-configuration" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/observatory-pages" dispatch={props.dispatch} element={<ObservatoryPages />} /> : <Route path="/admin/observatory-pages" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/observatory-pages/add" dispatch={props.dispatch} element={<ObservatoryPagesAdd />} /> : <Route path="/admin/observatory-pages" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/observatory-pages/edit/:pagecode" dispatch={props.dispatch} element={<ObservatoryPagesAdd />} /> : <Route path="/admin/observatory-pages" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/resources" dispatch={props.dispatch} element={<Resources />} /> : <Route path="/admin/resources" element={<Navigate to="/login" />} />}
              { state.loggedIn ? <Route path="/admin/change-password" dispatch={props.dispatch} element={<ChangePassword />} /> : <Route path="/admin/change-password" element={<Navigate to="/login" />} />}
              {/* <Route path="/*" element={<Navigate to={ WEB_FOLDER } />}  /> navigate to default route if no url matched */}
            </Routes>
            <Footer />
          <FooterBottom />
        </div>
      </body>
      </BrowserRouter>
      </JSONContext.Provider>
    </>      
    
  );
}

export default App;
